import { useState } from "react";
import { Grid, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Stack, useTheme } from "@mui/system";
import { CampaignOutlined, ReportOutlined } from "@mui/icons-material";

import referralIcon from "assets/images/referral/referral_1.svg";
import ReportGrantPopup from "./ReportGrant.Popup";
import ReferCharityPopup from "./ReferCharity.Popup";


const ReferralSection = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  
  const [openPopupReportGrant, setOpenPopupReportGrant] = useState(false);
  const [openPopupReferCharity, setOpenPopupReferCharity] = useState(false);

  return (
    <div>
        <Grid container wrap="nowrap" alignItems="center" sx={{
            backgroundColor: '#E0F2F142',
            marginLeft: '10px',
            paddingTop: '10px',
            paddingBottom: '1px',
            paddingLeft: '13px',
            borderRadius: '20px',
            zoom: 1.1,
            [theme.breakpoints.down('1100')]: {
                zoom: 0.9,
            },
            [theme.breakpoints.down('md')]: {
                paddingLeft: '8px',
                zoom: 0.85,
            },
        }}>
            <Grid item sx={{ display: { xs: 'none', md: 'block' } }}>
                <img
                    src={referralIcon}
                    alt="icon"
                    height={60}
                />
            </Grid>
            <Grid item>
                <Stack>
                    <Grid item>
                        <Typography
                            component="span"
                            sx={{
                                fontWeight: 'bold',
                                fontSize: { xs: '13px', sm: '15px', md: '17px' },
                            }}
                        >
                            {t('labels.earn_bonus_time')}
                        </Typography>
                    </Grid>

                    <Grid item>
                        <Button
                            startIcon={<ReportOutlined />}
                            variant="text"
                            color="secondary"
                            onClick={() => setOpenPopupReportGrant(true)}
                        >
                            {t('labels.report_grant')}
                        </Button>

                        <Button
                            startIcon={<CampaignOutlined />}
                            variant="text"
                            color="primary"
                            onClick={() => setOpenPopupReferCharity(true)}
                        >
                            {t('labels.refer_a_charity')}
                        </Button>
                    </Grid>
                </Stack>
            </Grid>
        </Grid>

        <ReportGrantPopup 
            openPopup={openPopupReportGrant}
            onClose={() => setOpenPopupReportGrant(false)}
        />

        <ReferCharityPopup 
            openPopup={openPopupReferCharity}
            onClose={() => setOpenPopupReferCharity(false)}
        />

    </div>
  );
};

export default ReferralSection;
